import { useSearchParam } from 'react-use';
import { useMemo } from 'react';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { isPolygonMapMode, MapMode } from '@pkgs/components/hooks/stores/search/slices/mapInteractionSlice';

import { usePromptStore } from './stores/search/usePromptStore';
import { SearchMode } from './stores/search/slices/searchModeSlice';

type UseLocationFilterInitialLocationParams = {
  visibleSearchMode?: SearchMode;
};

export function useLocationFilterInitialLocation(params?: UseLocationFilterInitialLocationParams): string {
  const visibleSearchMode = params?.visibleSearchMode;
  const { t } = useAppContext();
  const placeName = useSearchStore((state) => state.placeName);
  const promptValue = usePromptStore((state) => state.promptValue);

  const mapMode = useSearchParam('mapMode') as MapMode;

  return useMemo(() => {
    if (isPolygonMapMode(mapMode)) {
      return t('search.searchbar.drawArea');
    }
    if (mapMode === MapMode.BOUNDING_BOX_MODE) {
      return t('search.searchbar.mapSearch');
    }

    if (visibleSearchMode === SearchMode.AI) {
      return promptValue;
    }

    return placeName ?? '';
  }, [mapMode, t, placeName, promptValue, visibleSearchMode]);
}
